import React from 'react';
import './StatusBadge.css';

/**
 * Unified status badge component.
 *
 * Pass onClick to render a button. Hover and press lighten the background and leave the border colour unchanged.
 *
 * @param {string}  label       - Display text (can be a React node)
 * @param {string}  colorFamily - One of: green | yellow | amber | red | orange | blue | purple | pink | teal | gray
 * @param {'normal'|'small'} size - 'normal' (beefy, for tables/headers) | 'small' (subtle, for inline name badges)
 * @param {string}  [tooltip]   - Optional hover tooltip text
 * @param {string}  [className] - Additional CSS class names
 * @param {function} [onClick]  - When set, the badge is a button
 */
const StatusBadge = ({ label, colorFamily = 'gray', size = 'normal', tooltip, className = '', onClick }) => {
  const interactive = typeof onClick === 'function';
  const sizeClass = size === 'small' ? 'status-badge-small' : 'status-badge-normal';
  const tooltipClass = tooltip ? 'status-badge-has-tooltip' : '';
  const interactiveClass = interactive ? 'status-badge-interactive' : '';
  const classes = `status-badge ${sizeClass} badge-${colorFamily} ${tooltipClass} ${interactiveClass} ${className}`.trim();

  const content = (
    <>
      {label}
      {tooltip && (
        <div className="status-badge-tooltip">{tooltip}</div>
      )}
    </>
  );

  if (interactive) {
    return (
      <button type="button" className={classes} onClick={onClick}>
        {content}
      </button>
    );
  }

  return (
    <span className={classes}>
      {content}
    </span>
  );
};

export default StatusBadge;
